import { DateFormatPipe } from '@zeotap-ui/core';
import { curry } from 'ramda';

export const xAxisTickFormatting = curry((xAxisTickDateFormat, value) => {
  const dateFormatter = new DateFormatPipe();
  return dateFormatter.transform(value, xAxisTickDateFormat);
});
